import { axiosClient } from '../../axiosClient';
import type { AnalyticsFilterOptions, FormCSVData } from '../types';

type GetCSVData = Omit<AnalyticsFilterOptions, 'agentId'> & { formId: number };

export const getFormCsvData = ({
  deployId,
  formId,
  startDate,
  endDate,
}: GetCSVData) =>
  axiosClient.get<FormCSVData>(`/formdata/v2/${formId}/csv`, {
    params: {
      ...(deployId && { deploy_id: deployId }),
      ...(startDate && { start_time: startDate }),
      ...(endDate && { end_time: endDate }),
    },
  });
